/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { PortfolioWorkGalleryRequest } from './PortfolioWorkGalleryRequest'
import {
  PortfolioWorkGalleryRequestFromJSON,
  PortfolioWorkGalleryRequestFromJSONTyped,
  PortfolioWorkGalleryRequestToJSON,
} from './PortfolioWorkGalleryRequest'

/**
 * Adds nested create feature
 * @export
 * @interface PortfolioWorkMutableRequest
 */
export interface PortfolioWorkMutableRequest {
  /**
   *
   * @type {string}
   * @memberof PortfolioWorkMutableRequest
   */
  time?: string | null
  /**
   *
   * @type {string}
   * @memberof PortfolioWorkMutableRequest
   */
  price?: string | null
  /**
   *
   * @type {string}
   * @memberof PortfolioWorkMutableRequest
   */
  name?: string | null
  /**
   *
   * @type {Array<PortfolioWorkGalleryRequest>}
   * @memberof PortfolioWorkMutableRequest
   */
  gallery?: Array<PortfolioWorkGalleryRequest>
  /**
   *
   * @type {boolean}
   * @memberof PortfolioWorkMutableRequest
   */
  isPublished?: boolean
  /**
   *
   * @type {number}
   * @memberof PortfolioWorkMutableRequest
   */
  regionId?: number
  /**
   *
   * @type {number}
   * @memberof PortfolioWorkMutableRequest
   */
  tagId?: number | null
  /**
   *
   * @type {Blob}
   * @memberof PortfolioWorkMutableRequest
   */
  dummyFieldToHackOpenapiGenerator?: Blob | null
}

/**
 * Check if a given object implements the PortfolioWorkMutableRequest interface.
 */
export function instanceOfPortfolioWorkMutableRequest(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function PortfolioWorkMutableRequestFromJSON(json: any): PortfolioWorkMutableRequest {
  return PortfolioWorkMutableRequestFromJSONTyped(json, false)
}

export function PortfolioWorkMutableRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PortfolioWorkMutableRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    time: !exists(json, 'time') ? undefined : json['time'],
    price: !exists(json, 'price') ? undefined : json['price'],
    name: !exists(json, 'name') ? undefined : json['name'],
    gallery: !exists(json, 'gallery')
      ? undefined
      : (json['gallery'] as Array<any>).map(PortfolioWorkGalleryRequestFromJSON),
    isPublished: !exists(json, 'isPublished') ? undefined : json['isPublished'],
    regionId: !exists(json, 'regionId') ? undefined : json['regionId'],
    tagId: !exists(json, 'tagId') ? undefined : json['tagId'],
    dummyFieldToHackOpenapiGenerator: !exists(json, 'dummyFieldToHackOpenapiGenerator')
      ? undefined
      : json['dummyFieldToHackOpenapiGenerator'],
  }
}

export function PortfolioWorkMutableRequestToJSON(
  value?: PortfolioWorkMutableRequest | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    time: value.time,
    price: value.price,
    name: value.name,
    gallery:
      value.gallery === undefined
        ? undefined
        : (value.gallery as Array<any>).map(PortfolioWorkGalleryRequestToJSON),
    isPublished: value.isPublished,
    regionId: value.regionId,
    tagId: value.tagId,
    dummyFieldToHackOpenapiGenerator: value.dummyFieldToHackOpenapiGenerator,
  }
}
